export default __webpack_public_path__ + "static/media/24H_Orange.d9dcf2de.png";